import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import MainDrawer from "./components/MainDrawer";
import SignUp from "./components/SignUp";
import SignIn from "./components/SignIn";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import TermsAndConditions from "./components/TermsAndConditions";
import MultiFactorAuthentication from "./components/multiFactorAuthentication/MultiFactorAuthentication";
import "./App.css";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material";
import axios from "axios";
import { AppContext } from "./Context/AppContext";
import Container from "@mui/material/Container";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import {} from "./config/AxiosCustomConfig";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffff00",
      light: "#ffff00",
      dark: "#ffff00",
      contrastText: "#00000",
    },
  },
});

function App() {
  // const handleDrawerToggle = (e) => {
  //   e.stopPropagation();
  //   setMobileOpen(!mobileOpen);
  // };

  // const itemClick = ()=>{
  //   setMobileOpen(!mobileOpen);

  // }

  const [checkingCredential, isCheckingCredential] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [isSignup, setIsSignUp] = useState(false);
  const [isEula, setIsEula] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isMultiFactorAuthentication, setIsMultiFactorAuthentication] =
    useState(false);
  const [responseLoginToken, setResponseLoginToken] = useState(null);
  const [responseLoginMfaToken, setResponseLoginMfaToken] = useState(null);
  const [companyId, setCompanyId] = useState(0);

  const currentUrl = window.location.hostname;

  if (currentUrl === "transacti-lite.tradynamics.com") {
    axios.defaults.baseURL = "https://transacti.tradynamics.com/transactiapi";
  } else if (currentUrl === "transacti-liteuat.tradynamics.com") {
    axios.defaults.baseURL =
      "https://transacti-uat.tradynamics.com/transactiapi";
  } else {
    axios.defaults.baseURL = "http://localhost:83/transactiapi";
    axios.defaults.baseURL =
      "https://transacti-uat.tradynamics.com/transactiapi";
  }

  axios.interceptors.request.use(function (config) {
    // const token = store.getState().session.token;
    config.headers.Authorization = "Bearer " + localStorage.getItem("token");
    return config;
  });
  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      localStorage.setItem("token", response.headers["access-token"]);
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    const options = {
      method: "POST",
      url: "/User/isTokeValid.json",
    };
    axios(options)
      .then((res) => {
        if (res.data.response.is_autohorized === true) {
          isCheckingCredential(false);
          setIsLogin(true);
          setCompanyId(res.data.response.company_id);
        }
      })
      .catch((error) => {
        isCheckingCredential(false);
      });
  });

  if (checkingCredential === true) {
    return (
      <AppContext.Provider value={{ companyId }}>
        <Container
          maxWidth="sm"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Please wait... Loading data...
          </Typography>
          <LinearProgress />
        </Container>
      </AppContext.Provider>
    );
  }

  if (isLogin && companyId > 0) {
    return (
      <div>
        <AppContext.Provider value={{ companyId }}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <Router>
                <div className="App">
                  <MainDrawer />
                </div>
              </Router>
            </ThemeProvider>
          </StyledEngineProvider>
        </AppContext.Provider>
      </div>
    );
  }

  if (
    isLogin === false &&
    isSignup === false &&
    isEula === false &&
    isResetPassword === false &&
    isMultiFactorAuthentication === false
  ) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <div className="App">
              <SignIn
                setIsLogin={setIsLogin}
                setIsSignUp={setIsSignUp}
                setIsEula={setIsEula}
                setIsResetPassword={setIsResetPassword}
                setIsMultiFactorAuthentication={setIsMultiFactorAuthentication}
                setResponseLoginToken={setResponseLoginToken}
                setResponseLoginMfaToken={setResponseLoginMfaToken}
              />
            </div>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  if (isSignup === true) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <div className="App">
              <SignUp setIsSignUp={setIsSignUp} />
            </div>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  if (isEula === true) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <div className="App">
              <TermsAndConditions setIsEula={setIsEula} />
            </div>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  if (isResetPassword === true) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <div className="App">
              <ResetPassword isResetPassword={setIsResetPassword} />
            </div>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  if (isMultiFactorAuthentication === true) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <div className="App">
              <MultiFactorAuthentication
                setIsMultiFactorAuthentication={setIsMultiFactorAuthentication}
                setIsLogin={setIsLogin}
                responseLoginToken={responseLoginToken}
                responseLoginMfaToken={responseLoginMfaToken}
              />
            </div>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  return "";
}

export default App;
